import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Pill } from '../pill';
import style from './beta-tag.module.css';
import { FlexRow } from '../flex';
import { messages } from './messages';

export const BetaTag = () => {
  return (
    <FlexRow className={classnames(style.container)}>
      <Pill className={classnames(style['beta-pill'])} label={<FormattedMessage {...messages.beta} />} />
    </FlexRow>
  );
};
